module.exports = __webpack_public_path__ + "img/Icon.c9596665.png";